/**
 * The site owner's Nostr pubkey (hex). Homepage feeds only show content
 * published by this account — direct links to other authors' content
 * still resolve normally.
 *
 * npub: npub1marc26z8nh3xkj5rcx7ufkatvx6ueqhp5vfw9v5teq26z254renshtf3g0
 */
export const SITE_OWNER_PUBKEY = 'df478568479de26b4a83c1bdc4dbab61b5cc82e1a312e2b28bc815a12a951e67';
